export const styles = {
  wrapper: {
    backgroundColor: '#fff',
    padding: '30px 50px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  item: {
    backgroundColor: '#fff',
    maxWidth: 'max-content',
  },
  general: {
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    fontSize: 20,
    lineHeight: '23px',
    color: '#46AF3D',
    marginRight: 4,
  },
  valueDescription: {
    fontSize: 15,
    lineHeight: '18px',
    color: '#7C7C7C',
  },
  subTitle: {
    marginTop: 10,
    fontSize: 12,
    lineHeight: '14px',
    color: '#ADADAD',
  },
  circle: {
    marginRight: 10,
    height: 24,
    width: 24,
    borderRadius: '50%',
    backgroundColor: '#46AF3D',
  },
}
